import { Box, Button } from "@mui/material"
import COLORS from "../../common/FortesColors"

export function FortesButton(props: baseProps): JSX.Element {
  return <FortesButtonBase {...props} />
}

export function FortesButtonHighlighted(
  props: {
    highlightColor: string
    contentColor?: string
  } & baseProps
): JSX.Element {
  return (
    <FortesButtonBase
      {...props}
      sx_={{ backgroundColor: props.highlightColor, color: props.contentColor }}
    />
  )
}

export function FortesButtonCheckable(
  props: {
    checked: boolean
  } & baseProps
): JSX.Element {
  const sx_ = props.checked
    ? { backgroundColor: COLORS.lightPurple }
    : { backgroundColor: "white" }

  return <FortesButtonBase {...props} sx_={{ ...sx_, borderRadius: "14px" }} />
}

export function FortesUnderlineButton(props: baseProps): JSX.Element {
  return (
    <FortesButtonBase
      {...props}
      sx_={{
        maxHeight: "24px",
        margin: 0,
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    />
  )
}

interface baseProps {
  onClick: () => void
  children?: React.ReactNode
  icon?: React.ReactNode
  height?: string
  width?: string
  alt?: string
  onRightSide?: boolean
}

function FortesButtonBase(
  props: {
    sx_?: any
  } & baseProps
): JSX.Element {
  const height = props.height === undefined ? "42px" : props.height
  const iconMargin = props.children === undefined ? "0px" : "10px"
  const contentColor =
    props.sx_?.color === undefined ? COLORS.darkPurple : props.sx_.color
  const hoverAlt = props.alt
    ? props.onRightSide
      ? {
          border: "1px solid white",
          width: "auto",
          justifyContent: "start",
          "&::before": {
            marginInlineStart: "10px",
            marginInlineEnd: "10px",
            content: `"${props.alt}"`,
          },
          transform: "translateX(-100%) translateX(45px)",
        }
      : {
          border: "1px solid white",
          width: "auto",
          justifyContent: "start",
          "&::after": {
            marginInlineStart: "10px",
            marginInlineEnd: "10px",
            content: `"${props.alt}"`,
          },
          transform: "translateX(-2px)",
        }
    : {}
  return (
    <Button
      sx={{
        width: props.width,
        height: height,
        minWidth: "2px",
        minHeight: "2px",
        borderRadius: "999px",
        paddingInlineEnd: "10px",
        paddingInlineStart: "10px",
        margin: "10px",
        "&:hover": {
          backgroundColor: COLORS.darkPurple,
          color: "white",
          "&: > *": {
            fill: "white",
          },
          ...hoverAlt,
        },
        textTransform: "none",
        ...props.sx_,
        color: contentColor,
      }}
      onClick={props.onClick}
    >
      {props.icon && (
        <Box
          sx={{
            marginInlineEnd: iconMargin,
            display: "flex",
            alignItems: "center",
          }}
        >
          {props.icon}
        </Box>
      )}
      {props.children}
    </Button>
  )
}
